import React from 'react'
import Hero from '../components/Hero'

function Home() {
  return (
    <div className='container p-0 m-0'>
            <Hero/>
    </div>
  )
}

export default Home